import { useEffect } from 'react';
import useSearch from '../contexts/useSearch';

interface SearchInputProps {
  placeholder?: string;
  autoFocus?: boolean;
  style?: React.CSSProperties;
}

const SearchInput = ({
  placeholder = '',
  autoFocus = false,
  style,
}: SearchInputProps) => {
  const { term, setTerm, inputRef } = useSearch();

  // Handle autoFocus - refocus when this prop changes or on mount
  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus, inputRef]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'var(--card-bg)',
        padding: '8px 12px',
        margin: '0 10px 20px 10px',
        border: '1px solid var(--border)',
        ...style,
      }}
    >
      <input
        ref={inputRef}
        type="text"
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        placeholder={placeholder}
        style={{
          flex: 1,
          minWidth: 0,
          background: 'none',
          border: 'none',
          outline: 'none',
          fontSize: '1rem',
          color: 'var(--primary)',
          textAlign: 'center',
        }}
      />
      {term.length > 0 && (
        <button
          onClick={() => setTerm('')}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--primary-soft)',
            cursor: 'pointer',
            fontSize: '1.2rem',
            padding: '0 4px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SearchInput;
